import {
    FETCH_GAMES_REQUEST,
    FETCH_GAMES_SUCCESS,
    FETCH_GAMES_FAILURE,
    ADD_GAME_SUCCESS,
    UPDATE_GAME_SUCCESS,
    TOGGLE_GAME_STATUS_SUCCESS,
    DELETE_GAME_SUCCESS
  } from '../actions/gameActions';
  
  const initialState = {
    games: [],
    loading: false,
    error: null
  };

  const sameGameId = (a, b) => String(a || '') === String(b || '');
  
  const gameReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GAMES_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      case FETCH_GAMES_SUCCESS:
        return {
          ...state,
          loading: false,
          games: action.payload,
          error: null
        };
      case FETCH_GAMES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      case ADD_GAME_SUCCESS:
        return {
          ...state,
          games: [...state.games, action.payload]
        };
      case UPDATE_GAME_SUCCESS:
        return {
          ...state,
          games: state.games.map(game =>
            sameGameId(game._id, action.payload?._id) ? action.payload : game
          )
        };
      case TOGGLE_GAME_STATUS_SUCCESS:
        return {
          ...state,
          games: state.games.map(game =>
            sameGameId(game._id, action.payload?._id) ? action.payload : game
          )
        };
      case DELETE_GAME_SUCCESS:
        return {
          ...state,
          games: state.games.filter(game => !sameGameId(game._id, action.payload))
        };
      default:
        return state;
    }
  };
  
  export default gameReducer;